<template>
    <div class="container-wrap">
      <section id="home">
        <slot name="body"/>
      </section>
    </div>
</template>

<script>
  
  export default {
    name: "SectionHeader"
  }
</script>
<style lang="scss" scoped>
  @import '../assets/vuetify-overide.scss';
</style>